import { Trophy, Clock, Check } from 'lucide-react';
import { FeedPost } from './FeedPost';

export const Feed = ({
  feedFilter,
  setFeedFilter,
  showSendAgainOnly,
  setShowSendAgainOnly,
  selectedCategory,
  setSelectedCategory,
  isLoadingFeed,
  getFilteredFeed,
  // FeedPost props
  userId,
  userVotes,
  activeCommentPost,
  setActiveCommentPost,
  comments,
  commentText,
  setCommentText,
  commentCooldown,
  isPostingComment,
  addComment,
  upvotePost,
  flagPost,
  deletePost,
  flagComment,
  deleteComment,
  shareToSocial,
  formatTimestamp,
  setViewingProfile,
  setShowProfile,
  getUserCategoryBreakdown,
  getUserRecentSends,
  AUTO_HIDE_FLAG_THRESHOLD,
  MAX_COMMENT_LENGTH,
  MIN_COMMENT_LENGTH,
}) => {
  return (
    <div className="space-y-4 px-3 sm:px-4">
      {/* Feed Filters */}
      <div className="bg-gray-900 border-3 border-purple-500 p-4" data-community-feed>
        <div className="flex flex-wrap gap-2 sm:gap-3 mb-4">
          <button
            onClick={() => { setFeedFilter('top'); setSelectedCategory('all'); }}
            className={`px-4 py-2 font-black uppercase text-sm border-2 transition-all ${feedFilter === 'top'
              ? 'bg-purple-500 text-black border-purple-400'
              : 'bg-black text-purple-500 border-purple-500 hover:bg-purple-900'
              }`}
          >
            <Trophy size={16} className="inline mr-1" />
            TOP THIS WEEK
          </button>
          <button
            onClick={() => { setFeedFilter('recent'); setSelectedCategory('all'); }}
            className={`px-4 py-2 font-black uppercase text-sm border-2 transition-all ${feedFilter === 'recent'
              ? 'bg-purple-500 text-black border-purple-400'
              : 'bg-black text-purple-500 border-purple-500 hover:bg-purple-900'
              }`}
          >
            <Clock size={16} className="inline mr-1" />
            RECENT
          </button>
          <button
            onClick={() => { setShowSendAgainOnly(true); setSelectedCategory('all'); }}
            className={`px-4 py-2 font-black uppercase text-sm border-2 transition-all ${showSendAgainOnly
              ? 'bg-lime-500 text-black border-lime-400'
              : 'bg-black text-lime-500 border-lime-500 hover:bg-lime-900'
              }`}
          >
            <Check size={16} className="inline mr-1" />
            WOULD SEND AGAIN
          </button>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => setSelectedCategory('all')}
            className={`px-3 py-1 font-black uppercase text-xs border-2 transition-all ${selectedCategory === 'all'
              ? 'bg-lime-500 text-black border-lime-400'
              : 'bg-black text-gray-500 border-gray-700 hover:border-lime-500'
              }`}
          >
            ALL
          </button>
          {['social', 'money', 'creative', 'gym', 'anti-opt', 'chaos'].map(cat => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-3 py-1 font-black uppercase text-xs border-2 transition-all ${selectedCategory === cat
                ? 'bg-lime-500 text-black border-lime-400'
                : 'bg-black text-gray-500 border-gray-700 hover:border-lime-500'
                }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Feed Content */}
      {isLoadingFeed ? (
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-gray-900 border-3 border-gray-700 p-5 sm:p-7 overflow-hidden relative">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 bg-gray-700 border-2 border-gray-600 animate-shimmer"></div>
                  <div className="w-24 h-4 bg-gray-700 animate-shimmer"></div>
                </div>
              </div>
              <div className="flex gap-2 mb-4">
                <div className="w-20 h-6 bg-gray-700 animate-shimmer"></div>
                <div className="w-16 h-6 bg-gray-700 animate-shimmer"></div>
              </div>
              <div className="space-y-2 mb-5">
                <div className="w-full h-4 bg-gray-700 animate-shimmer"></div>
                <div className="w-5/6 h-4 bg-gray-700 animate-shimmer"></div>
                <div className="w-4/6 h-4 bg-gray-700 animate-shimmer"></div>
              </div>
              <div className="border-t-2 border-gray-800 pt-4">
                <div className="flex items-center gap-2">
                  <div className="w-20 h-10 bg-gray-700 animate-shimmer"></div>
                  <div className="w-20 h-10 bg-gray-700 animate-shimmer"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : getFilteredFeed().length === 0 ? (
        <div className="bg-gray-900 border-3 border-gray-700 p-8 text-center">
          <p className="text-gray-500 font-black text-lg uppercase">NO POSTS YET • BE THE FIRST!</p>
        </div>
      ) : (
        getFilteredFeed().map((post) => (
          <FeedPost
            key={post.id}
            post={post}
            userId={userId}
            userVotes={userVotes}
            activeCommentPost={activeCommentPost}
            setActiveCommentPost={setActiveCommentPost}
            comments={comments}
            commentText={commentText}
            setCommentText={setCommentText}
            commentCooldown={commentCooldown}
            isPostingComment={isPostingComment}
            addComment={addComment}
            upvotePost={upvotePost}
            flagPost={flagPost}
            deletePost={deletePost}
            flagComment={flagComment}
            deleteComment={deleteComment}
            shareToSocial={shareToSocial}
            formatTimestamp={formatTimestamp}
            setViewingProfile={setViewingProfile}
            setShowProfile={setShowProfile}
            getUserCategoryBreakdown={getUserCategoryBreakdown}
            getUserRecentSends={getUserRecentSends}
            AUTO_HIDE_FLAG_THRESHOLD={AUTO_HIDE_FLAG_THRESHOLD}
            MAX_COMMENT_LENGTH={MAX_COMMENT_LENGTH}
            MIN_COMMENT_LENGTH={MIN_COMMENT_LENGTH}
          />
        ))
      )}
    </div>
  );
};
